/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { BuilderUserContext } from '@gh/builder-shared';
import {
  Month,
  SubOfficeRestService,
  SubOfficeStatus,
} from '@gh/builder-shared-data';
import {
  DictionaryService,
  getRouteParam,
  globalDictionaries,
  InitViewService,
  isRouteForCreationMode,
} from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { currentYear } from '@gh/core-util';
import { map$ } from '@gh/rx/operators';
import { range } from 'lodash';
import { Observable } from 'rxjs';
import { OfficeListItem } from '../../offices/resources/office-list-item.model';
import {
  SUB_OFFICE_INIT,
  SubOfficeDetails,
  subOfficeDetailsFromDto,
  subOfficeDetailsToDto,
} from './sub-office-details.model';
import { of$ } from '@gh/rx';
import { OfficeDetails, officeDetailsFromDto } from '../../offices/resources/office-details.model';

@Injectable()
export class SubOfficeDetailsBusinessService implements InitViewService {
  constructor(private officeRest: SubOfficeRestService,
              private dictionaryService: DictionaryService,
              private userContext: BuilderUserContext) {

  }

  initView(route: ActivatedRouteSnapshot): any {
    return {
      officeStatuses: this.dictionaryService.getByEnum(SubOfficeStatus),
      financialYears: range(currentYear() - 2, currentYear() + 3),
      months: this.dictionaryService.getByEnum(Month),
      states: this.dictionaryService.get(globalDictionaries.states),
      officeDetails: isRouteForCreationMode(route) ? this.getNew() : this.get(getRouteParam(route, 'officeId')),
      franchiseeOffices: this.getOffices(),
      parentOffice: this.userContext.officeView && this.userContext.office?.id ?
                     this.getFranchiseeOffice(this.userContext.office?.id) : '',
    };
  }

  create(details: SubOfficeDetails): Observable<SubOfficeDetails> {
    return this.officeRest.create(subOfficeDetailsToDto(details)).pipe(map$(subOfficeDetailsFromDto));
  }

  update(details: SubOfficeDetails): Observable<SubOfficeDetails> {
    return this.officeRest.update(subOfficeDetailsToDto(details)).pipe(map$(subOfficeDetailsFromDto));
  }

  get(id: ID): Observable<SubOfficeDetails> {
    return this.officeRest.get(id).pipe(map$(subOfficeDetailsFromDto));
  }

  getNew(): Observable<any> {
    const initData = SUB_OFFICE_INIT;
    if (this.userContext.officeView && this.userContext.office?.id) {
      initData.officeId = this.userContext.office?.id;
    }
    return of$(initData);
  }

  getFranchiseeOffice(id: ID): Observable<OfficeDetails> {
    return this.officeRest.getFranchiseeOffice(id).pipe(map$(officeDetailsFromDto));
  }

  getOffices(): Observable<OfficeListItem[]> {
    if (this.userContext.masterZone?.id) {
      return this.officeRest.getFranchiseeOffices();
    }
    return of$ ([]);
  }

}
